import newLayout from '@/layout';
import { roterPre } from '@/settings';
var pathUrl = "".concat(roterPre, "/user");
var companyRouter = {
  path: pathUrl,
  name: 'users',
  meta: {
    title: '用户管理'
  },
  alwaysShow: true,
  component: newLayout,
  children: [{
    path: 'resume',
    component: function component() {
      return import('@/views/user/resume/index');
    },
    name: 'resume',
    meta: {
      title: '我的简历',
      noCache: true
    }
  }, {
    path: roterPre + '/program/programList/taskDetails',
    component: function component() {
      return import('@/views/program/programList/taskDetails.vue');
    },
    name: 'taskDetails',
    meta: {
      title: '项目详情'
    }
  }, {
    path: roterPre + '/program/programList/dynamics',
    component: function component() {
      return import('@/views/program/programList/dynamics.vue');
    },
    name: 'dynamics',
    meta: {
      title: '项目动态'
    }
  }, {
    path: roterPre + '/hr/attendance/setting/addConent',
    component: function component() {
      return import('@/views/hr/attendance/setting/addConent.vue');
    },
    name: 'addConent',
    meta: {
      title: '新增考勤设置'
    }
  }, {
    path: roterPre + '/develop/dictionary/management',
    component: function component() {
      return import('@/views/develop/dictionary/management');
    },
    name: 'management',
    meta: {
      title: '字典管理'
    }
  }, {
    path: roterPre + '/develop/crud/design',
    component: function component() {
      return import('@/views/develop/crud/design');
    },
    name: 'design',
    meta: {
      title: '实体设计'
    }
  }, {
    path: 'news/subscribe',
    component: function component() {
      return import('@/views/user/news/subscribe');
    },
    name: 'subscribe',
    meta: {
      title: '订阅消息',
      noCache: true
    }
  }]
};
export default companyRouter;